import styled from "styled-components";

const Spacer = styled.div`
    padding: 8px 0 48px 0;
    display: flex;
    flex-direction: row;
`

export default Spacer;